import { Navigate } from "react-router-dom";
import { DialogsProvider } from "@/context/DialogsContext";
import SEOPageLayout from "@/components/seo/SEOPageLayout";
import QuoteFormDialog from "@/components/forms/QuoteFormDialog";
import { useSEO } from "@/hooks/useSEO";
import { getRegionPageBySlug, REGION_PAGES } from "@/data/seo/regionPages";
import { getPhase1MainServices } from "@/data/seo/mainServices";
import { getPhase1Cities } from "@/data/seo/cities";
import { WHY_US_ITEMS, FAQ_ITEMS } from "@/constants/business";
import { localBusinessSchema, serviceSchema, faqSchema, breadcrumbSchema } from "@/lib/schema";

export default function RegionPage({ regionSlug }) {
  const region = getRegionPageBySlug(regionSlug);

  const path = `/${regionSlug}`;
  const description = region?.metaDescription || "";
  const faqSubset = FAQ_ITEMS.slice(0, 6);
  const phase1Cities = getPhase1Cities();
  const otherRegionPages = region ? REGION_PAGES.filter((r) => r.slug !== region.slug) : [];

  const breadcrumbItems = region ? [{ label: "Accueil", href: "/" }, { label: region.h1 }] : [];

  useSEO({
    title: region?.metaTitle || "",
    description,
    path,
    isIndexable: !!region?.isPhase1,
    jsonLd: region
      ? [
          localBusinessSchema(),
          serviceSchema({ name: region.h1, description, url: path }),
          faqSchema(faqSubset),
          breadcrumbSchema(breadcrumbItems),
        ]
      : null,
  });

  if (!region) return <Navigate to="/404" replace />;

  const relatedGroups = [
    {
      title: "Nos villes en Normandie",
      items: phase1Cities.map((c) => ({ label: c.name, href: `/transport-${c.slug}` })),
    },
    {
      title: "Autres zones",
      items: otherRegionPages.map((r) => ({ label: r.h1, href: `/${r.slug}` })),
    },
  ];

  return (
    <DialogsProvider>
      <SEOPageLayout
        testIdPrefix="region-page"
        breadcrumbItems={breadcrumbItems}
        eyebrow="Zone d'intervention"
        h1={region.h1}
        intro={region.intro}
        serviceLinks={getPhase1MainServices().map((s) => ({ label: s.label, href: `/${s.slug}` }))}
        trustItems={WHY_US_ITEMS.slice(0, 6).map((i) => i.text)}
        relatedGroups={relatedGroups}
        faqItems={faqSubset}
        ctaProfile="particulier"
      />
      <QuoteFormDialog />
    </DialogsProvider>
  );
}
